import { apiService } from './apiService';

// Helper function to convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  
  const camelObj = {};
  Object.keys(obj)?.forEach(key => {
    const camelKey = key?.replace(/_([a-z])/g, (g) => g?.[1]?.toUpperCase());
    camelObj[camelKey] = obj?.[key];
  });
  return camelObj;
};

export const whatsappService = {
  // Create WhatsApp request (public access)
  async createRequest(contentId, userName, userPhone, message = '') {
    try {
      const response = await fetch('/api/whatsapp/create.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          contentId,
          userName,
          userPhone,
          message,
          status: 'pending'
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to create request');
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating WhatsApp request:', error);
      throw error;
    }
  },

  // Format WhatsApp message
  formatWhatsAppMessage(content, userName) {
    const message = `Olá! Sou ${userName} e gostaria de solicitar a arte: "${content?.title}"`;
    const encodedMessage = encodeURIComponent(message);
    const phoneNumber = '5511999999999'; // Replace with actual business phone
    return `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  },

  // Open WhatsApp with pre-filled message
  openWhatsApp(content, userName) {
    const url = this.formatWhatsAppMessage(content, userName);
    window.open(url, '_blank');
  }
};
